import { Middleware } from "openapi-fetch";
import i18n from "../../i18n";
import { AUTOLOGIN_USER, AUTOLOGIN_PASS } from "../../environments";
import { store, accessTokenInfoAtom } from "../../store";
import { expToExpiredAt } from "../token";
import { getVariantValue } from "../variantTunnel";
import { voislogApi } from "./voislogApi";
import { WafBlockError } from "./WafBlockError";

// WAFのブロック時にカスタムレスポンスへ付与されるヘッダー
const WAFBLOCK_HEADER = "X-Blocked-By-Waf";

// WAFのメンテナンスブロック時にカスタムレスポンスへ付与されるヘッダー
const MAINTENANCE_MODE_HEADER = "X-Maintenance-Mode";

export const wafMiddleware: Middleware = {
  onResponse({ response }) {
    const { status, headers } = response;

    if (status == 503 && headers.get(MAINTENANCE_MODE_HEADER) === "True") {
      const message = i18n.t("Error.waf.maintenance");
      window.alert(message);
      window.location.reload();
      return Promise.reject(new WafBlockError(message));
    }

    if (status == 403 && headers.get(WAFBLOCK_HEADER) === "True") {
      const message = i18n.t("Error.waf.blocked");
      window.alert(message);
      window.location.reload();
      return Promise.reject(new WafBlockError(message));
    }
  },
};

export const authMiddleware: Middleware = {
  onRequest({ request }) {
    if (request.headers.has("Authorization")) return;
    const tokenInfo = store.get(accessTokenInfoAtom);
    if (tokenInfo) {
      request.headers.set("Authorization", `Bearer ${tokenInfo.access_token}`);
    }
  },
};

/**
 * 自動ログイン用ミドルウェア。
 * ENABLE_AUTO_LOGIN が有効な場合にのみ voislogApi.use() される。
 * 401を受け取った際にトークンを再取得し、元のリクエストをリトライする。
 */
export const autoLoginMiddleware: Middleware = {
  async onResponse({ request, response }) {
    if (response.status !== 401) return;
    // /auth/token 自体の401は無限ループ防止のためスキップ
    if (request.url.includes("/v2/core/auth/token")) return;

    try {
      const { data } = await voislogApi.POST("/v2/core/auth/token", {
        body: { email: AUTOLOGIN_USER, password: AUTOLOGIN_PASS },
      });
      if (!data) return;
      const { access_token } = data;

      // storeのトークン情報を更新
      const currentToken = store.get(accessTokenInfoAtom);
      if (currentToken) {
        store.set(accessTokenInfoAtom, {
          ...currentToken,
          access_token,
          expired_at: expToExpiredAt(access_token),
        });
      }

      // 元のリクエストをリトライ
      const retryRequest = new Request(request, {
        headers: new Headers(request.headers),
      });
      retryRequest.headers.set("Authorization", `Bearer ${access_token}`);
      return fetch(retryRequest);
    } catch (e) {
      console.error("Auto login token refresh failed:", e);
    }
  },
};

export const variantTunnelMiddleware: Middleware = {
  onRequest({ request }) {
    const variantValue = getVariantValue();
    if (variantValue === null) return;
    request.headers.set("X-Backend-Variant", variantValue);
  },
};
